export default {
  root: {
    justifyContent: 'center'
  },
  chip: {
    marginBottom: '16px'
  }
};
